document.addEventListener("DOMContentLoaded", function() {
	  function triggerBooking({ staff = "", service = "", store = "", category = "" } = {}) {
	    const clientelaShadowRoot = document.getElementById("ClientelaChatID")?.shadowRoot;
	    if (!clientelaShadowRoot) return false;

	    const clientelaOpenBtn  = clientelaShadowRoot.getElementById("clientela-rs-btn-text"),
	          clientelaBackBtn  = clientelaShadowRoot.getElementById("clientela-backbtn"),
	          clientelaStartPane= clientelaShadowRoot.getElementById("clientela-rsStart");

	    if (!clientelaOpenBtn) return false;

	    clientelaOpenBtn.click();

	    clientelaShadowRoot.host.dispatchEvent(new CustomEvent("clientela:book", {
	      detail: { staff, service, store, category },
	      bubbles: true,
	      composed: true
	    }));

	    if (clientelaBackBtn)  clientelaBackBtn.style.display = "none";
	    if (clientelaStartPane) clientelaStartPane.style.display = "none";

	    return true;
	  }

	  // Use event delegation so dynamically-injected .appointment-btn elements
	  // (e.g. from store-locator.js) are handled without needing a re-bind.
	  document.addEventListener("click", (e) => {
	    const button = e.target.closest(".appointment-btn");
	    if (!button) return;
	    triggerBooking({
	      staff:    button.dataset.staff    || "",
	      service:  button.dataset.service  || "",
	      store:    button.dataset.store    || "",
	      category: button.dataset.category || ""
	    });
	  });

	  const params = new URLSearchParams(window.location.search);
	  const rsParam = (params.get("rs") || "").toLowerCase();
	  const shouldAutoTrigger = rsParam === "1" || rsParam === "true" || rsParam === "yes";
	  if (shouldAutoTrigger) {
	    const urlPayload = {
	      staff:    params.get("staff")    || "",
	      service:  params.get("service")  || "",
	      store:    params.get("store")    || "",
	      category: params.get("category") || ""
	    };
	    if (!urlPayload.store || !urlPayload.category || !urlPayload.staff || !urlPayload.service) {
	      const firstBtn = document.querySelector(".appointment-btn");
	      if (firstBtn) {
	        urlPayload.staff    = urlPayload.staff    || firstBtn.dataset.staff    || "";
	        urlPayload.service  = urlPayload.service  || firstBtn.dataset.service  || "";
	        urlPayload.store    = urlPayload.store    || firstBtn.dataset.store    || "";
	        urlPayload.category = urlPayload.category || firstBtn.dataset.category || "";
	      }
	    }
	    let attempts = 0;
	    const MAX_ATTEMPTS = 40;
	    const interval = setInterval(() => {
	      attempts++;
	      const ok = triggerBooking(urlPayload);
	      if (ok || attempts >= MAX_ATTEMPTS) clearInterval(interval);
	    }, 50);
	  }
	});